/**
 * Localization utilities for resolving locale-aware content
 */
/**
 * Extracts the language code from a locale string
 * @param locale - Locale string (e.g., 'en-US', 'es-MX')
 * @returns Language code (e.g., 'en', 'es')
 */
export const getLanguageFromLocale = (locale) => locale.split('-')[0];
/**
 * Resolves a localized text value with fallback cascade
 * @param params - Resolution parameters
 * @returns Resolved text value
 */
export const resolveLocalizedText = ({ legacyValue, localizedMap, enabled, locale, defaultLocale, }) => {
    if (!enabled) {
        return legacyValue;
    }
    if (!localizedMap || typeof localizedMap !== 'object') {
        return legacyValue;
    }
    const activeLocale = locale || defaultLocale || 'en';
    const language = getLanguageFromLocale(activeLocale);
    // 1. Try exact locale match (e.g., 'en-US')
    if (localizedMap[activeLocale]) {
        return localizedMap[activeLocale];
    }
    // 2. Try language fallback (e.g., 'en')
    if (language && localizedMap[language]) {
        return localizedMap[language];
    }
    // 3. If active locale is default, fall back to legacy
    if (activeLocale === defaultLocale) {
        return legacyValue;
    }
    // 4. Try default locale
    if (defaultLocale && localizedMap[defaultLocale]) {
        return localizedMap[defaultLocale];
    }
    // 5. Try English fallback
    if (defaultLocale !== 'en' && localizedMap.en) {
        return localizedMap.en;
    }
    // 6. Fall back to legacy value
    return legacyValue;
};
/**
 * Resolves a localized text array value with fallback cascade
 * Note: The localizedMap uses strings with bullet separator (•), not arrays.
 * The parsing to array is done in the Conversation component.
 * @param params - Resolution parameters
 * @returns Resolved text value (string with separator or array)
 */
export const resolveLocalizedTextArray = ({ legacyValue, localizedMap, enabled, locale, defaultLocale, }) => {
    if (!enabled) {
        return legacyValue;
    }
    if (!localizedMap || typeof localizedMap !== 'object') {
        return legacyValue;
    }
    const activeLocale = locale || defaultLocale || 'en';
    const language = getLanguageFromLocale(activeLocale);
    // 1. Try exact locale match (e.g., 'en-US')
    if (localizedMap[activeLocale] && localizedMap[activeLocale].trim()) {
        return localizedMap[activeLocale];
    }
    // 2. Try language fallback (e.g., 'en')
    if (language && localizedMap[language] && localizedMap[language].trim()) {
        return localizedMap[language];
    }
    // 3. If active locale is default, fall back to legacy
    if (activeLocale === defaultLocale) {
        return legacyValue;
    }
    // 4. Try default locale
    if (defaultLocale && localizedMap[defaultLocale] && localizedMap[defaultLocale].trim()) {
        return localizedMap[defaultLocale];
    }
    // 5. Try English fallback
    if (defaultLocale !== 'en' && localizedMap.en && localizedMap.en.trim()) {
        return localizedMap.en;
    }
    // 6. Fall back to legacy value
    return legacyValue;
};
//# sourceMappingURL=localization.js.map